import { ActionCardsCallbacks, ActionCardsConfig, ActionCardsSettings } from '@playbooks/action-cards/types'
import { ActionCardsElement } from '@playbooks/action-cards'
import ActionCards from '@playbooks/action-cards'
import { cn } from '@playbooks/ui/lib/utils'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { RefObject } from 'react'
import type { ActionCardsActions } from '@playbooks/action-cards/types'

interface ActionCardsViewProps {
  config: ActionCardsConfig
  actionCard: ActionCard
  settings: ActionCardsSettings
  callbacks: ActionCardsCallbacks
  actionCardsElementRef: React.RefObject<ActionCardsElement | null>
  scrollContainer: RefObject<HTMLDivElement | null>
  actions: ActionCardsActions
}

function ActionCardsView({
  config,
  settings,
  callbacks,
  actionCard,
  actionCardsElementRef,
  scrollContainer,
  actions,
}: ActionCardsViewProps) {
  return (
    <div
      ref={scrollContainer}
      data-role="webplay-carousel"
      className={cn(`flex h-full overflow-hidden transition-[filter]`)}
    >
      <ActionCards
        config={config}
        value={actionCard}
        settings={settings}
        ref={actionCardsElementRef}
        onChange={callbacks.onChange}
        onLastSlideVisible={callbacks.onLastSlideVisible}
        actions={actions}
      />
    </div>
  )
}

export default ActionCardsView
